import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'myt-load-spinner',
    imports: [MatProgressSpinnerModule],
    templateUrl: './load-spinner.component.html',
    styleUrl: './load-spinner.component.scss'
})
export class LoadSpinnerComponent {

}
